import React from 'react';
import Services from '../components/Services';
import PageHero from '../components/PageHero';
import SEO from '../components/SEO';
import { useLanguage } from '../context/LanguageContext';
import { SITE_URL } from '../config/site';
import './PageStyles.css';

const ServicesPage = () => {
  const { t } = useLanguage();

  return (
    <div className="page-container">
      <SEO
        title="Dental Services in Dar es Salaam | Dr. Muyabins Dental Care"
        description="General dentistry, teeth cleaning, cosmetic dentistry, orthodontics, implants, whitening, and emergency care in Dar es Salaam, Tanzania."
        keywords="dental services Tanzania, teeth cleaning Dar es Salaam, orthodontics, cosmetic dentistry, dental implants"
        url={`${SITE_URL}/services`}
      />
      <PageHero
        title={t('pages.servicesTitle')}
        subtitle={t('pages.servicesSubtitle')}
        breadcrumb={[
          { label: 'Home', href: '/' },
          { label: t('nav.services') },
        ]}
      />
      <Services hideHeader variant="page" />
    </div>
  );
};

export default ServicesPage;
